// src/components/EnrollButton.js
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';
import { enrollUserInCourse } from '../services/user_info'; // adjust the path as needed
import { Unlock, Lock, PlayCircle, ArrowUpCircle, Loader2 } from 'lucide-react';

const AccountSpecificMessage = ({account_type}) => {
  return (
    <>
    {account_type === 'paid' && (
        <span className='premium-specific-message'>
          conta premium
        </span>
    )}
    {account_type === 'free' && (
        <span className='free-specific-message'>
          conta gratuita
          <br /><a href='/premium'>fazer upgrade</a>
        </span>
    )}
    </>
  );
};

const AccountSpecificMessagePublic = ({account_type}) => {
  return (
    <>
    {account_type === 'paid' && (
        <span className='premium-specific-message'>
          conta premium
        </span>
    )}
    {account_type === 'free' && (
        <span className='free-specific-message'>
          conta gratuita
        </span>
    )}
    </>
  );
};

const EnrollButton = ({ courseId, availability, account_type, onEnroll }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { user, getIdToken } = useAuth();

  const handleEnroll = async () => {
    if (!user) {
      setError('Please log in to enroll in this course');
      return;
    }
    setLoading(true);
    setError(null);
    if (account_type == 'free' && availability == 'paid') {
      navigate(`/premium`);
    } else {
        try {
          const token = await getIdToken();
          const result = await enrollUserInCourse(token, courseId); // using imported function
          if (result.error) {
            console.error('Enrollment failed:', result.error);
          } else if (onEnroll) {
            onEnroll(); // notify parent component to update state
          }
        } catch (error) {
          console.error('Enrollment failed:', error);
          setError(error.message || 'Failed to enroll in course');
        } finally {
          setLoading(false);
        }
    }
  };

  return (
    <div className="cta-home-page-wrapper">
      {error && <div className="enroll-error">{error}</div>}
      {/* <a href="/signup" className="cta-home-page cta-home-create-free"><Unlock size={18} /> Criar conta gratuita</a> */}
      <button 
        onClick={handleEnroll}
        disabled={loading}
        className={(account_type === 'paid' || availability === 'free') ? ("cta-home-page cta-home-page-login") : ("cta-home-page cta-home-page-quero")}
      >
        {loading ? (
          <>
            <Loader2 className="animate-spin" size={18} />
            Processando...
          </>
        ) : (
          (account_type === 'paid' || availability === 'free') ? (
            <>
              <PlayCircle size={18} />
              Começar curso agora
            </>
          ) : (
            <>
              <Lock size={18} />
              Faça upgrade para começar
            </>
          )
        )}
      </button>
    </div>
  );
};

export {EnrollButton, AccountSpecificMessage, AccountSpecificMessagePublic};
